export default "/images/mydev-light.svg?04f746fa40ab0b89d205420437076f3b";